module.exports = __webpack_public_path__ + "static/media/ConnectOneBank_Logo.42118e63.jpg";